"use client";

import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useBackend } from "./useBackend";

/**
 * Hook for fetching the list of user's video jobs with pagination.
 * Data is considered stale after 20 seconds.
 */
export function useVideoJobs(limit: number = 20, offset: number = 0) {
  const backend = useBackend();

  return useQuery({
    queryKey: ["videos", limit, offset],
    queryFn: () => backend.video.list({ limit, offset }),
    staleTime: 20_000, // 20s before refetch
  });
}

/**
 * Hook for cancelling a pending or processing video job.
 */
export function useCancelVideo() {
  const backend = useBackend();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => backend.video.cancel(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["videos"] });
    },
  });
}

/**
 * Hook for deleting a completed or failed video job.
 */
export function useDeleteVideo() {
  const backend = useBackend();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => backend.video.deleteVideo(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["videos"] });
    },
  });
}
